import React, { useState } from 'react';
import Modal from './Modal';
import { stripeAPI } from '../../services/api';

const PurchaseSeatsModal = ({ isOpen, onClose }) => {
  const [seats, setSeats] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubscribe = async () => {
    if (seats < 10) {
      setError('Minimum 10 seats required for Path A.');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await stripeAPI.subscribePathA(seats);
      if (res.data && res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.error('Failed to subscribe:', err);
      setError(err.response?.data?.error || 'Failed to start subscription process. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Subscribe to Path A" maxWidth="max-w-md">
      <div className="space-y-6">
        <div>
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
            Purchase a block of active client seats to invite your clients to communicate with your AI avatar for free. You pay $100/seat/month, minimum 10 seats.
          </p>
        </div>

        {error && (
          <div className="p-4 bg-orange-500/5 border border-orange-500/20 rounded-2xl text-orange-500 text-xs font-bold flex items-start gap-2">
            <span className="material-symbols-outlined text-base shrink-0">warning</span>
            <span className="leading-normal">{error}</span>
          </div>
        )}

        {/* Seat Counter */}
        <div className="bg-[var(--off-white)] border border-[var(--border-light)] p-5 rounded-2xl flex items-center justify-between gap-4">
          <div>
            <label className="block text-xs font-black text-[var(--text-secondary)]/60 uppercase tracking-widest mb-1">
              Seats Block
            </label>
            <p className="text-xs text-[var(--text-secondary)] font-medium">Price: <span className="font-bold text-[var(--text-primary)]">$100/seat/mo</span></p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setSeats(prev => Math.max(10, prev - 1))}
              disabled={seats <= 10 || loading}
              className="w-10 h-10 rounded-xl bg-[var(--surface-white)] border border-[var(--border-light)] text-[var(--text-primary)] flex items-center justify-center font-bold shadow-sm hover:border-[var(--tangerine)] transition-all disabled:opacity-40"
            >
              —
            </button>
            <input
              type="number"
              min="10"
              value={seats}
              onChange={(e) => {
                const val = parseInt(e.target.value, 10);
                setSeats(isNaN(val) ? 10 : val);
              }}
              disabled={loading}
              className="w-16 text-center bg-[var(--surface-white)] border border-[var(--border-light)] rounded-xl font-bold py-2 focus:ring-[var(--tangerine)] focus:border-[var(--tangerine)] text-sm shadow-sm"
            />
            <button
              onClick={() => setSeats(prev => prev + 1)}
              disabled={loading}
              className="w-10 h-10 rounded-xl bg-[var(--surface-white)] border border-[var(--border-light)] text-[var(--text-primary)] flex items-center justify-center font-bold shadow-sm hover:border-[var(--tangerine)] transition-all disabled:opacity-40"
            >
              +
            </button>
          </div>
        </div>

        {/* Total Pricing Preview Card */}
        <div className="p-4 bg-[var(--off-white)] border border-[var(--border-light)] rounded-2xl space-y-2 text-xs">
          <div className="flex justify-between">
            <span className="text-[var(--text-secondary)]">Seats block</span>
            <span className="font-bold text-[var(--text-primary)]">{seats} seats</span>
          </div>
          <div className="flex justify-between">
            <span className="text-[var(--text-secondary)]">Price per seat</span>
            <span className="font-bold text-[var(--text-primary)]">$100.00/mo</span>
          </div>
          <div className="flex justify-between border-t border-[var(--border-light)]/40 pt-2 mt-2">
            <span className="text-[var(--text-secondary)] font-bold">Total monthly subscription</span>
            <span className="font-bold text-tangerine text-sm">${seats * 100}.00/mo</span>
          </div>
        </div>

        {/* Checkout Button */}
        <button
          onClick={handleSubscribe}
          disabled={loading || seats < 10}
          className="w-full py-3 bg-[var(--tangerine)] hover:bg-[#d97700] text-white font-bold rounded-2xl shadow shadow-tangerine/20 hover:-translate-y-0.5 disabled:transform-none disabled:opacity-75 transition-all text-sm flex items-center justify-center gap-2"
        >
          {loading && <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />}
          <span className="material-symbols-outlined text-lg">credit_card</span>
          {loading ? 'Redirecting to Stripe...' : `Subscribe — $${seats * 100}/mo`}
        </button>

        {/* Cancel Action */}
        <div className="flex justify-end pt-2 border-t border-[var(--border-light)]/40">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-5 py-2 text-sm font-bold text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseSeatsModal;
